// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__tcmp5","bigColWidth":"Table_bigColWidth__3h0Zt","biggerColWidth":"Table_biggerColWidth__ZeRNq","row":"Table_row__WtTo-","col":"Table_col__3rMc1"};